<template>
  <div id="FeaturedProject">
    <b-container
      class="images"
      @click="
        setModalData({ modalType: 'project', data: huehearData });
        analyticsHelper.modalOpen('huehear featured');
      "
    >
      <div class="a outera">
        <img :src="require('@/assets/images/screenshots/huehear/dhht-0.png')" />
      </div>
      <div class="b outerb" v-if="global.screenWidth > 650">
        <div class="b innerb">
          <div class="a innerinnera">
            <img
              :src="require('@/assets/images/screenshots/huehear/dhht-8.png')"
            />
          </div>
          <div class="b innerinnerb">
            <img
              :src="require('@/assets/images/screenshots/huehear/dhht-4.png')"
            />
          </div>
        </div>
      </div>
    </b-container>
    <b-container class="content-container">
      <h3>Hue Hear</h3>
      <span>{{
        projectData
          .find((x) => x.categoryName === "web")
          .items.find((x) => x.title === "Hue Hear")
          .stack.filter((x) => x)
          .join(" \u2022 ")
      }}</span>
      <p
        v-html="
          languageHelper.translate('huehear.desc', {
            locale: global.locale,
          })
        "
      ></p>
      <a
        href="https://huehear.com"
        target="_blank"
        @click="analyticsHelper.clickedLink('huehear - featured')"
        ><span class="visit">
          {{
            languageHelper.translate("common.visit", {
              locale: global.locale,
            })
          }}
        </span></a
      >
    </b-container>
  </div>
</template>

<script>
import projectData from "@/data/projectData";
import { languageHelper, analyticsHelper } from "@/helpers";
import { mapActions, mapState } from "vuex";
export default {
  name: "FeaturedProject",
  data() {
    return {
      huehearData: projectData[0].items[2],
      languageHelper,
      analyticsHelper,
      projectData,
    };
  },
  computed: {
    ...mapState(["global"]),
  },
  methods: {
    ...mapActions(["setModalData"]),
  },
};
</script>

<style lang="scss" scoped>
$mobile: $md;
#FeaturedProject {
  width: 100%;
  z-index: 5;
  background: #fff;
  padding-top: 100px;
  padding-bottom: 100px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .content-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
  }
  .visit {
    font-family: $font-secondary !important;
    font-size: 14px !important;
    color: $lt-dark-gray;
    align-self: flex-end;
  }
  h3 {
    font-size: 52px;
    font-family: $font-header;
    margin-top: 40px;
  }
  span {
    color: $lt-secondary-color;
    font-size: 17px;
    font-family: $font-header;
    margin-top: 4px;
    max-width: 90%;
  }
  a {
    text-decoration: none;
    outline: none;
  }
  p {
    font-size: 20px;
    font-family: $font-primary;
    width: 650px;
    margin-top: 20px;
    max-width: 100%;
    text-align: center;
  }

  .images {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    max-height: 520px;
    height: 520px;
    width: 100%;
    overflow: hidden;
    cursor: pointer;
    @media (max-width: $mobile) {
      max-width: 100%;
      padding: 0 20px;
    }

    img {
      height: 100%;
      width: 100%;
      object-fit: cover;
      border-radius: 22px;
      border: 1px solid $lt-gray;
    }
    .a {
      display: flex;
      flex: 1;
    }
    .b {
      display: flex;
      flex: 1.25;
    }
    .d {
      height: 50%;
      max-height: 50%;
      width: 100%;
      max-width: 100%;
      padding-right: 8px;
      &:first-child {
        padding-bottom: 8px;
      }
      &:last-child {
        padding-top: 8px;
      }
      @media (max-width: $mobile) {
        padding-right: 4px;
        &:first-child {
          padding-bottom: 4px;
        }
        &:last-child {
          padding-top: 4px;
        }
      }
    }
    .e {
    }
    .outera {
      // width: 45%;
      height: 100%;
      padding-right: 8px;
      @media (max-width: $mobile) {
        padding-right: 4px;
      }
      @media (max-width: $lg) {
        // width: 50%;
        flex: 1.25;
      }
    }
    .outerb {
      height: 100%;
      padding-left: 8px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-between;
      @media (max-width: $mobile) {
        padding-left: 4px;
      }
    }
    .innera {
      width: 100%;
      height: 45%;
      padding-bottom: 8px;
      img {
        object-position: top;
      }
      @media (max-width: $mobile) {
        padding-bottom: 4px;
      }
    }
    .innerb {
      width: 100%;
      height: 55%;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      padding-top: 8px;
      @media (max-width: $mobile) {
        padding-top: 4px;
      }
    }
    .innerinnera {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-between;
      height: 100%;
      max-height: 100%;
      @media (max-width: $lg) {
        display: none;
      }
    }
    .innerinnerb {
      height: 100%;
      padding-left: 8px;
      @media (max-width: $mobile) {
        padding-left: 4px;
      }
    }
    .col-container {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      flex: 1;
      max-height: 100px;
    }
  }
}
</style>

<style lang="scss" >
$mobile: $md;
.dark {
  #FeaturedProject {
    background: $dt-bg-color;

    h3 {
      color: $dt-font-color;
    }
    span {
      color: $dt-secondary-color;
    }
    p {
      color: $dt-font-color;
    }
    .visit {
      color: $lt-gray;
    }
  }
}
</style>

